import { Box, CardActions, CardHeader, Dialog as MuiDialog, DialogActions, DialogContent, DialogTitle, IconButton, Theme, List, ListItem } from '@mui/material';
import * as React from 'react';
import {Card as MuiCard, CardContent} from '@mui/material';
import Icon from 'components/icons/Icon';
import SubHeading from 'components/labels/SubHeading';
import Button from 'components/buttons/Button';
import Container from 'components/layout/Container';
import { ColorsUtil, ColourType, MyTheme } from 'MyTheme';
import LoadingButton from 'components/buttons/LoadingButton';
import { useState } from 'react';
import Login from 'views/authentication/Login';
import LoginForm from 'views/authentication/LoginForm';
import Dialog from 'components/modals/Dialog';
import { IPermission } from './Permission';
import Checkbox from 'components/toggle/checkbox/Checkbox';
import Text from 'components/labels/Text';

export interface PermissionsDialogProps{
    open: boolean;
    permissions: IPermission[];
    // onClose: () => any;
    onResult: (permissionIds: string[]) => any;
}

const PermissionsDialog = (props: PermissionsDialogProps) => {
    const {permissions, open, onResult, ...rest} = props;
    const [selectedIds, setSelectedIds] = React.useState<Set<string>>(new Set(permissions.filter(p => p.isRequired).map(p => p.id)));
    //const 
    // const handleSubmit = (val: boolean) => {
    //     if(!val)
    //         return;
    //     cb([]);
    // }

    // const cb = (val: string[]) => {
    //     onClose();
    //     onResult && onResult(val);
    // }

    const handlePermissionToggle = (id: string) => {
        const isSelected = !selectedIds.has(id);
        if(isSelected)
            selectedIds.add(id);
        else
            selectedIds.delete(id);

        setSelectedIds(new Set(Array.from(selectedIds)));
    }

    return(
        <Dialog
            open={open}
            maxWidth="xs" 
            title={"Integration Setup"}
            onClose={() => onResult([])}
            action={<Button variant="contained" onClick={() => onResult(Array.from(selectedIds))}>Ok</Button>}
            
            {...rest}
        >
            <List disablePadding>
                {permissions.map(p => {
                    return <ListItem>
                        <Box display='flex' alignItems='flex-start'>

                        <Checkbox
                            simple
                            disabled={p.isRequired}
                            checked={selectedIds.has(p.id)}
                            onClick={() => handlePermissionToggle(p.id)}
                        />

                        <Box ml={1}>
                            <Text>{p.displayName}</Text>
                            <Box fontSize='10px'>{p.note}</Box>
                        </Box>
                        </Box>

                    </ListItem>
                })}
            </List>
        </Dialog>
    ) 
}

export default PermissionsDialog;